import {
  getFilterValueFromType,
  upsertQueryFilterNode,
} from '@modules/queryBuilder/helpers';
import { QueryBuilderActionType } from '@modules/queryBuilder/store/queryBuilderActionType';
import { useQueryBuilderStore } from '@modules/queryBuilder/store/useQueryBuilderStore';
import { Option } from '@modules/queryBuilder/types';
import { CloseRounded } from '@mui/icons-material';
import {
  IconButton,
  ListItem,
  ListItemButton,
  ListItemText,
} from '@mui/material';
import { NormalisedFilter } from 'v2/querybuilder/types/querystore';

interface QueryFilterNLSSelectedOptionProps {
  option: Option;
  filter: NormalisedFilter;
}

export const QueryFilterNLSSelectedOption = ({
  option,
  filter,
}: QueryFilterNLSSelectedOptionProps) => {
  const dispatch = useQueryBuilderStore(({ dispatch }) => dispatch);
  const nodes = useQueryBuilderStore(({ query }) => query.nodes);
  const removeNLSKeyword = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    value: string,
  ) => {
    event.stopPropagation();
    const currentValues =
      filter.value.type === 'string[]' &&
      filter.value.values.map((value) => value.value);

    if (!currentValues) {
      return;
    }

    const newValues = currentValues.filter((item) => item !== value);

    const updatedNodes = upsertQueryFilterNode({
      node: {
        ...filter,
        value: getFilterValueFromType({
          value: newValues,
          type: filter.value.type,
        }),
      },
      nodesByID: nodes,
      parentID: filter.parent,
    });

    dispatch({
      type: QueryBuilderActionType.SET_QUERY,
      payload: {
        nodes: updatedNodes,
      },
    });
  };

  return (
    <ListItem
      disablePadding
      secondaryAction={
        <IconButton
          onClick={(event) => removeNLSKeyword(event, option.displayName)}
        >
          <CloseRounded />
        </IconButton>
      }
    >
      <ListItemButton disableRipple>
        <ListItemText
          key={option.id}
          primary={option.displayName}
          color="text.secondary"
        />
      </ListItemButton>
    </ListItem>
  );
};
